import { NgModule } from '@angular/core';
import { CustomComponentsModule } from './components/components.module';
import { CustomConfigModule } from './configurations/configurations.module';
import { CustomConverterModule } from './converters/converter.module';
import { CustomGuardsModule } from './guards/guards.module';
import { CustomResolversModule } from './meta-resolver/meta-resolver.module';
import { CustomServicesModule } from './services/services.module';

@NgModule({
  imports: [
    CustomConfigModule,
    CustomComponentsModule,
    CustomResolversModule,
    CustomGuardsModule,
    CustomServicesModule,
    CustomConverterModule,
  ],
})
export class CustomModule {}
